/***********************************************************************************************
 *  Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  NonMSAPOProductsDeleteNotification.tsx
 *
 * Project Title :  Checkout
 *
 * Description	: UT test cases for ProductAddedNotification.tsx
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422337
 *
 * @Date		 : Nov 04 2020
 *
 * @Version      : Version 1.0
 *
 * By            : H422337
 * On            : Nov, 05 2020
 * Description   : ASDS-3268 UI Enhancements for Phase-II & Delete All MSA products
 *
 * By            : H422337
 * On            : Nov, 05 2020
 * Description   : ASDS-4083 UI Enhancements for Phase-II  bug fix & Delete All  products from the cart
 *
 **********************************************************************************************/

import React from 'react';
import { Notification } from '@scuf/common';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import RouteConstants from '../constants/route-constants';
import ProductAlertActions from '../redux/actions/products-alerts-action';
import CartDetailsActions from '../redux/actions/cart-details-actions';

interface IToast {
    closeToast: any;
    hideAlert: Function;
    updateDeleteNonMSAPOSuccessFlag: Function;
    msgTitle: string;
    msgBody: string;
    deleteNonMSAPOSuccessFlag: boolean;
    deleteAllProductsSuccessFlag: boolean;
}

class NonMSAPOProductsDeleteNotification extends React.Component<IToast & RouteComponentProps> {
    constructor(props: IToast & RouteComponentProps) {
        super(props);
        this.handleCartLink = this.handleCartLink.bind(this);
        this.onCloseMsg = this.onCloseMsg.bind(this);
    }

    handleCartLink() {
        this.props.history.push(RouteConstants.MY_CART);
        this.props.updateDeleteNonMSAPOSuccessFlag(false);
    }
    onCloseMsg() {
           this.props.closeToast();
           this.props.updateDeleteNonMSAPOSuccessFlag(false);

    }

    render() {
        return (
            <React.Fragment>
                <Notification
                    className="toast-notification product-change"
                    hasIcon={true}
                    title={this.props.msgTitle}
                    severity="important"
                    detailsText="View Cart"
                    onDetailsClick={this.handleCartLink}
                    onCloseClick={this.onCloseMsg}
                >
                    {this.props.msgBody}
                </Notification>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = {
    hideAlert: ProductAlertActions.hideAlert,
    updateDeleteNonMSAPOSuccessFlag:  CartDetailsActions.updateDeleteNonMSAPOSuccessFlag,
};

function mapStateToProps(state) {
    return {
        deleteNonMSAPOSuccessFlag: state.cartDetails.deleteNonMSAPOSuccessFlag,
        deleteAllProductsSuccessFlag: state.cartDetails.deleteAllProductsSuccessFlag
     };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NonMSAPOProductsDeleteNotification));
